/**
 * Eventos internos do funil e mapeamento para os eventos nativos de cada provider.
 * Novo provider = nova entrada em PROVIDER_EVENTS + arquivo em ./providers.
 *
 * Nomes padrão Selecty: são exibidos ao cliente na tela "Marketing e Rastreamento" do admin para ele configurar
 * conversões e públicos. Manter igual a PortalMarketingService::TRACKED_EVENTS (selecty4-application).
 * Trocar um nome depois que o cliente começou a anunciar quebra o histórico de conversões na conta dele.
 */
export const JOB_VIEW = "job_view";
export const APPLICATION_START = "application_start";
export const APPLICATION_COMPLETE = "application_complete";

/**
 * Padrão Selecty (fallback). O nome efetivo vem da config do portal (marketing.<provider>.events),
 * que pode ter nomes personalizados pelo cliente na tela do admin.
 */
export const PROVIDER_EVENTS = {
    meta: {
        [JOB_VIEW]: "ViewContent",
        [APPLICATION_START]: "InitiateCheckout",
        [APPLICATION_COMPLETE]: "Lead",
    },
    google: {
        [JOB_VIEW]: "view_item",
        [APPLICATION_START]: "begin_checkout",
        [APPLICATION_COMPLETE]: "generate_lead",
    },
    tiktok: {
        [JOB_VIEW]: "ViewContent",
        [APPLICATION_START]: "InitiateCheckout",
        [APPLICATION_COMPLETE]: "SubmitForm",
    },
};

/**
 * Únicas chaves que podem sair do portal para plataformas de marketing (sem PII).
 */
export const PAYLOAD_WHITELIST = [
    "event_name",
    "event_id",
    "job_id",
    "job_title",
    "portal_id",
    "source",
    "medium",
    "campaign",
];

export const CONSENT_ANALYTICS = "analytics";
export const CONSENT_ADVERTISING = "advertising";

/**
 * Eventos padrão da Meta: enviados com "trackSingle". Qualquer outro nome é evento personalizado e
 * precisa de "trackSingleCustom" (exigência da Meta). Manter igual a PortalMarketingService::META_STANDARD_EVENTS.
 */
export const META_STANDARD_EVENTS = [
    "AddPaymentInfo", "AddToCart", "AddToWishlist", "CompleteRegistration", "Contact", "CustomizeProduct",
    "Donate", "FindLocation", "InitiateCheckout", "Lead", "Purchase", "Schedule", "Search", "StartTrial",
    "SubmitApplication", "Subscribe", "ViewContent",
];

/**
 * Nome efetivo do evento para a plataforma: personalizado na config do portal ou padrão Selecty.
 */
export function eventName(provider, config, internalEvent) {
    const custom = config && config.events ? config.events[internalEvent] : null;

    return custom || (PROVIDER_EVENTS[provider] ? PROVIDER_EVENTS[provider][internalEvent] : null);
}
